import React from 'react';
import PropTypes from 'prop-types';

import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import TelephoneInput from 'dpl/form/components/TelephoneInput';
import { get } from 'dpl/shared/utils/object';

const INPUT_NAME = 'buyer_profile_attributes.user_attributes.phone_number';
const OPT_IN_NAME =
  'buyer_profile_attributes.buyer_notification_setting_attributes.sms';

export default function QuizPhoneNumberQuestion({
  formState,
  addToFormState,
  handleNextClick,
  breederName
}) {
  const phoneNumber = get(formState, INPUT_NAME, '');

  function onClickNext() {
    addToFormState(OPT_IN_NAME, true, handleNextClick);
  }

  return (
    <div className="AdoptionApplcationQuizPhoneNumberQuestion">
      <FullPageQuizQuestion
        handleNextClick={onClickNext}
        isValid={phoneNumber?.length === 10}
        title="What's your phone number?"
        subtitle={`Enter your phone number to get notified when ${breederName} sends you a
        message or approves your application. You can change your notification
        settings anytime.`}
      >
        <p />
        <TelephoneInput
          name={INPUT_NAME}
          placeholder="e.g. 555-555-5555"
          value={phoneNumber}
        />
      </FullPageQuizQuestion>
      <p className="FullPageQuizQuestion center tc f2">
        By clicking &apos;Continue,&apos; you consent to receive service and
        offer-related text messages from Good Dog at the number provided, like
        when a breeder approves your application or sends you a message.
        Messages may be sent using automated systems for the selection and
        dialing of numbers. Consent is not a condition of any purchase. Reply
        STOP to unsubscribe any time. Message and data rates may apply.
      </p>
    </div>
  );
}

QuizPhoneNumberQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  addToFormState: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  breederName: PropTypes.string.isRequired
};
